import { useDataSourceList } from './dataSourceList';
import { useInstalledDataSourceList } from './dataSourceInstalled';

const hooks = {
    useDataSourceList,
    useInstalledDataSourceList
}

export default hooks;